"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _userCanUpdateField = require("../../../../../schema/security/user-can-update-field");
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, " Restriction Info:");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, " Sessions per event per day");
class DivisionDetail extends _react.Component {
  // *******************************************************************************
  // Render
  // *******************************************************************************

  render() {
    const division = this.props.division;
    const competitionID = this.props.competitionID;
    const user = this.props.user;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 7,
        md: 6
      }, {
        sm: 5,
        md: 6
      }]
    }, !division.isRestricted ? null : /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: (0, _userCanUpdateField.userCanUpdateDivisionField)('restriction', competitionID, user),
      preparedForEdit: true,
      type: "textArea",
      name: "restriction",
      value: division.restriction,
      onChange: this.props.onChange
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: (0, _userCanUpdateField.userCanUpdateDivisionField)('sessionsPerDay', competitionID, user),
      preparedForEdit: true,
      type: "Integer",
      name: "sessionsPerDay",
      value: division.sessionsPerDay,
      maxLength: 1,
      onChange: this.props.onChange
    }))))));
  }
  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(DivisionDetail, "partials", {
  Division: {
    id: true,
    isRestricted: true,
    restriction: true,
    sessionsPerDay: true
  }
});
var _default = exports.default = DivisionDetail;